let elements = {
  blockCheck: true,
  fontFamily: 'Linotype',
  fontSize: '45px',
  mainImage: {
    imagePath: 'games/page020_game1/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  correctBorderRadius: '12px',
  withoutCheck: false,
  columns: 3,
  audio: {
    negative: 'games/page020_game1/audio/false.mp3',
    positive: 'games/page020_game1/audio/true.mp3',
    click: 'games/page020_game1/audio/click.mp3',
  },
  imageHighlight: true,
  curtain: 'transparent',
  curtainImage: {
    src: 'games/page020_game1/img/des.webp',
  },
  width: 466,
  bcgImg: 'games/page020_game1/img/desBcg.webp',
  height: 366,
  // goodAudio: 'games/page020_game1/audio/z2c2.mp3',
  colors: ['#00a8ec', '#f7a82b', '#ff0000'],
  pick: 3,
  fields: [
    {
      id: 0,
      image: {
        src: 'games/page020_game1/img/15.png',
      },
      audioSrc: 'games/page020_game1/audio/15.mp3',
      pair: {
        id: 0,
        image: {
          src: 'games/page020_game1/img/15.png',
        },
        audioSrc: 'games/page020_game1/audio/15.mp3',
      },
    },
    {
      id: 1,
      image: {
        src: 'games/page020_game1/img/16.png',
      },
      audioSrc: 'games/page020_game1/audio/16.mp3',
      pair: {
        id: 1,
        image: {
          src: 'games/page020_game1/img/16.png',
        },
        audioSrc: 'games/page020_game1/audio/16.mp3',
      },
    },
    {
      id: 2,
      image: {
        src: 'games/page020_game1/img/17.png',
      },
      audioSrc: 'games/page020_game1/audio/17.mp3',
      pair: {
        id: 2,
        image: {
          src: 'games/page020_game1/img/17.png',
        },
        audioSrc: 'games/page020_game1/audio/17.mp3',
      },
    },
    {
      id: 3,
      image: {
        src: 'games/page020_game1/img/18.png',
      },
      audioSrc: 'games/page020_game1/audio/18.mp3',
      pair: {
        id: 3,
        image: {
          src: 'games/page020_game1/img/18.png',
        },
        audioSrc: 'games/page020_game1/audio/18.mp3',
      },
    },
    {
      id: 4,
      image: {
        src: 'games/page020_game1/img/19.png',
      },
      audioSrc: 'games/page020_game1/audio/19.mp3',
      pair: {
        id: 4,
        image: {
          src: 'games/page020_game1/img/19.png',
        },
        audioSrc: 'games/page020_game1/audio/19.mp3',
      },
    },
    {
      id: 5,
      image: {
        src: 'games/page020_game1/img/20.png',
      },
      audioSrc: 'games/page020_game1/audio/20.mp3',
      pair: {
        id: 5,
        image: {
          src: 'games/page020_game1/img/20.png',
        },
        audioSrc: 'games/page020_game1/audio/20.mp3',
      },
    },
    {
      id: 6,
      audioSrc: 'games/page020_game1/audio/21.mp3',
      image: {
        src: 'games/page020_game1/img/21.png',
      },
      pair: {
        id: 6,
        image: {
          src: 'games/page020_game1/img/21.png',
        },
        audioSrc: 'games/page020_game1/audio/21.mp3',
      },
    },
    {
      id: 7,
      audioSrc: 'games/page020_game1/audio/22.mp3',
      image: {
        src: 'games/page020_game1/img/22.png',
      },
      pair: {
        id: 7,
        image: {
          src: 'games/page020_game1/img/22.png',
        },
        audioSrc: 'games/page020_game1/audio/22.mp3',
      },
    },
    {
      id: 8,
      audioSrc: 'games/page020_game1/audio/23.mp3',
      image: {
        src: 'games/page020_game1/img/23.png',
      },
      pair: {
        id: 8,
        image: {
          src: 'games/page020_game1/img/23.png',
        },
        audioSrc: 'games/page020_game1/audio/23.mp3',
      },
    },
    {
      id: 9,
      audioSrc: 'games/page020_game1/audio/24.mp3',
      image: {
        src: 'games/page020_game1/img/24.png',
      },
      pair: {
        id: 9,
        image: {
          src: 'games/page020_game1/img/24.png',
        },
        audioSrc: 'games/page020_game1/audio/24.mp3',
      },
    },
    {
      audioSrc: 'games/page020_game1/audio/25.mp3',
      id: 10,
      image: {
        src: 'games/page020_game1/img/25.png',
      },
      pair: {
        id: 10,
        image: {
          src: 'games/page020_game1/img/25.png',
        },
        audioSrc: 'games/page020_game1/audio/25.mp3',
      },
    },
    {
      audioSrc: 'games/page020_game1/audio/26.mp3',
      id: 11,
      image: {
        src: 'games/page020_game1/img/26.png',
      },
      pair: {
        id: 11,
        image: {
          src: 'games/page020_game1/img/26.png',
        },
        audioSrc: 'games/page020_game1/audio/26.mp3',
      },
    },
    {
      audioSrc: 'games/page020_game1/audio/27.mp3',
      id: 12,
      image: {
        src: 'games/page020_game1/img/27.png',
      },
      pair: {
        id: 12,
        image: {
          src: 'games/page020_game1/img/27.png',
        },
        audioSrc: 'games/page020_game1/audio/27.mp3',
      },
    },
    {
      audioSrc: 'games/page020_game1/audio/28.mp3',
      id: 13,
      image: {
        src: 'games/page020_game1/img/28.png',
      },
      pair: {
        id: 13,
        image: {
          src: 'games/page020_game1/img/28.png',
        },
        audioSrc: 'games/page020_game1/audio/28.mp3',
      },
    },
  ],
  // mbAudioItemData: [
  // ],
};
export default elements;
